import React, { useContext, useEffect, useState } from 'react';
import AppNav from './navigation/AppNav';
// Removed react-native-toast-notifications
import { Platform, Text, View } from 'react-native';
import NetInfo from '@react-native-community/netinfo';
import { ExtrasContext } from './Context/ExtrasContext';
import SplashScreen from 'react-native-splash-screen';
// Safe area is now handled inside the navigator
import Navloader from './components/Reusables/NavLoader/Navloader';

const Body = () => {
  useEffect(() => {
    // react-native-splash-screen is native-only; avoid crashing on web
    if (Platform.OS !== 'web' && SplashScreen?.hide) {
      SplashScreen.hide();
    }
  }, []);

  const { setNetworkAvailableGlobal } = useContext(ExtrasContext);
  const [hasCheckedConnectivity, setHasCheckedConnectivity] = useState(false);

  useEffect(() => {
    const init = async () => {
      try {
        const state = await NetInfo.fetch();
        // Only set network state if we have a definitive answer
        // If isInternetReachable is null, it's still checking - don't set to false yet
        if (state.isInternetReachable !== null) {
          const isOnline = !!state.isConnected && !!state.isInternetReachable;
          setNetworkAvailableGlobal(isOnline);
        }
        // If still checking, keep the default true value and let the listener handle it
      } catch (e) {
        setNetworkAvailableGlobal(false);
      } finally {
        setHasCheckedConnectivity(true);
      }
    };
    init();

    const unsubscribe = NetInfo.addEventListener(state => {
      // Skip until we have a definitive reachability answer (null = still checking)
      if (state.isInternetReachable === null) return;

      const isOnline = !!state.isConnected && state.isInternetReachable;
      setNetworkAvailableGlobal(isOnline);
    });

    return () => unsubscribe();
  }, []);

  if (!hasCheckedConnectivity) {
    return (
      <View style={{ flex: 1, backgroundColor: '#1560bd' }}>
        <Navloader />
      </View>
    );
  }

  return (
    <View
      style={{
        // backgroundColor: '#1560bd',
        flex: 1,
      }}>
      {/* Snackbar handled globally by AppSnackbarHost */}
      <AppNav />
    </View>
  );
};

export default Body;
